// extracted by mini-css-extract-plugin
export default {"dropzone":"styles-module__dropzone__src-labstep-web-core-Dropzone-Children-_fXzdO","text":"styles-module__text__src-labstep-web-core-Dropzone-Children-_ag9HX"};